import { authedAxios } from '../shared/axiosWrapper';
import {
  AD_BASE_PHONE_NUMBER_PATH,
} from '../constants';

export default {
  fetchByNumber(phoneNumber) {
    return authedAxios.get(AD_BASE_PHONE_NUMBER_PATH + 'number/' + phoneNumber);
  },
  fetchPhoneNumbers() {
    // Just fetch them all for now. Paginate eventually
    return authedAxios.get(AD_BASE_PHONE_NUMBER_PATH, {
      params: {
        sort: 'label:asc',
      }});
  },
  changeLabel(id, label) {
    return authedAxios.put(AD_BASE_PHONE_NUMBER_PATH + id + '/change-label',
      {label: label});
  },
  changeCallPlan(id, callPlanId) {
    return authedAxios.put(AD_BASE_PHONE_NUMBER_PATH + id + '/change-callplan',
      {call_plan_id: callPlanId});
  },
  changeSource(numberId, payload) {
    return authedAxios.put(
      AD_BASE_PHONE_NUMBER_PATH + numberId + '/change-source',
      payload
    );
  },
  changeBrand(numberId, brandId) {
    return authedAxios.put(
      AD_BASE_PHONE_NUMBER_PATH + numberId + '/change-brand',
      {brand_id: brandId}
    );
  },
}

